export const ShowGridMethodName: string = "T42.ExcelPad.ShowGrid";
export const ValidateShowGridMethodName: string = "ValidateShowGrid";
